// extracted by mini-css-extract-plugin
export default {"-large":"KUAi8KIAhaK7OrLu2tXa","text":"kzErDy4MN1QZJ5Qf3fAJ","noWrap":"AdhOZ_xvAgzhcAs3x7IL","wrapText":"OBhkjxuysR2B0i01tiaZ","inputCounter":"WOugRJJfcQeR3p5zcZ22"};